// Membership API Handler
window.CFCustomerHelper = {
  endpoint: 'https://astonishing-empanada-476b41.netlify.app/.netlify/functions/update-customer',
  shopDomain: 'db8yzm-xj.myshopify.com',
  
  addTag: function(customerId) {
    return fetch(this.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: this.shopDomain,
        customer_id: customerId
      })
    }).then(function () {
        // window.location.href = '/account?view=my-page';
        window.location.href = '/pages/my-page';
    });
  }
};